<template>
  <form
    class="needs-validation mt-3"
    novalidate=""
    data-vv-scope="addressForm"
    @submit.prevent="action('addressForm')"
  >
    <div class="row m-0">
      <div class="col-md-3 mb-3">
        <label
          for="firstName"
          id="dlvry-adrs-firstname-heading"
										data-test="AddressFormFNname"
        >
          First Name
        </label>
        <input
          type="text"
          class="form-control"
          id="firstName"
          name="firstname"
          v-validate="'required|min:3|alpha'"
          v-model="user.firstName"
          :class="(addressFormError &&
          errors.has('addressForm.firstname'))?'is-invalid':''"
										data-test="AddressFormFNnameInput"
        >
        <div
          class="invalid-feedback"
          v-if="(addressFormError && errors.has('addressForm.firstname'))"
          id="dlvry-adrs-firstname-error"
										data-test="AddressFormFNnameError"
        >
          {{errors.first('addressForm.firstname')}}
        </div>
      </div>
      <div class="col-md-3 mb-3">
        <label
          for="lastName"
          id="dlvry-adrs-lastname-heading"
										data-test="AddressFormLNname"
        >Last Name</label>
        <input
          type="text"
          class="form-control"
          id="lastName"
          name="lastname"
          v-validate="'required|min:1|alpha'"
          v-model="user.lastName"
          :class="(addressFormError &&
          errors.has('addressForm.lastname'))?'is-invalid':''"
										data-test="AddressFormLNnameInput"
        >
        <div
          class="invalid-feedback"
          v-if="(addressFormError && errors.has('addressForm.lastname'))"
          id="dlvry-adrs-lastname-error"
										data-test="AddressFormLNnameError"
        >
          {{errors.first('addressForm.lastname')}}
        </div>
      </div>

      <div class="col-md-3 mb-3">
        <label
          for="phone"
          id="dlvry-adrs-phnno-heading"
										data-test="AddressFormPhnNo"
        >
          Phone Number
        </label>
        <div class="input-group">
          <!--<div class="input-group-prepend">-->
          <!--<span class="input-group-text">@</span>-->
          <!--</div>-->
          <input
            type="text"
            class="form-control"
            id="phone"
            name="phone"
            v-validate="'required|min:10|max:10|numeric'"
            v-model="user.phoneNo"
            placeholder=""
            :class="(addressFormError &&
            errors.has('addressForm.phone'))?'is-invalid':''"
												data-test="AddressFormPhnNoInput"
          >
          <!--<vue-tel-input-->
          <!--v-model="user.phoneNo"-->
          <!--name="phoneNumber"-->
          <!--@onInput="onInput"-->
          <!--:preferredCountries="['us', 'gb', 'in']"-->
          <!--:disabledFetchingCountry="false"-->
          <!--:enabledFlags="true"-->
          <!--@onValidate="phoneError = false"-->
          <!--v-validate="'required'"-->
          <!--@onBlur="showError = true"-->
          <!--&gt;-->
          <!--</vue-tel-input>-->
          <!--<span v-if="showError && phoneError" style="color: red">-->
          <!--Phone Number Should be Valid-->
          <!--</span>-->
          <div
            class="invalid-feedback"
            v-if="(addressFormError && errors.has('addressForm.phone'))"
            id="dlvry-adrs-phone-error"
												data-test="AddressFormPhnNoError"
          >
            {{errors.first('addressForm.phone')}}
          </div>
        </div>
      </div>

      <div class="col-md-3 mb-3">
        <label
          for="email"
          id="dlvry-adrs-email-heading"
										data-test="AddressFormEmail"
        >
          Email
          <span class="text-muted"
																data-test="AddressFormEmailSpan">
            (Optional)
          </span>
        </label>
        <input
          type="email"
          class="form-control"
          id="email"
          name="email"
          v-model="user.email"
          placeholder=""
          :class="(addressFormError &&
          errors.has('addressForm.email'))?'is-invalid':''"
          v-validate="'email'"
										data-test="AddressFormEmailInput"
        >
        <div
          class="invalid-feedback"
          v-if="(addressFormError && errors.has('addressForm.email'))"
          id="dlvry-adrs-email-error"
										data-test="AddressFormEmailError"
        >
          Please enter a valid email address for shipping updates.
        </div>
      </div>
    </div>
    <div class="row m-0">
      <div class="col-md-6 mb-3">
        <label
          for="address"
          id="dlvry-adrs-line1-heading"
										data-test="AddressFormAddress1"
        >
          Address Line 1
        </label>
        <input
          type="text"
          class="form-control"
          id="address"
          name="address"
          placeholder=""
          v-validate="'required|min:3'"
          v-model="user.addressLine1"
          :class="(addressFormError &&
          errors.has('addressForm.address'))?'is-invalid':''"
										data-test="AddressFormAddress1Input"
        >
        <div
          class="invalid-feedback"
          v-if="(addressFormError && errors.has('addressForm.address'))"
          id="dlvry-adrs-line1-error"
										data-test="AddressFormAddress1Error"
        >
          {{errors.first('addressForm.address')}}
        </div>
      </div>

      <div class="col-md-6 mb-3">
        <label
          for="address2"
          id="dlvry-adrs-line2-heading"
										data-test="AddressFormAddress2"
        >
          Address Line 2
          <!--<span class="text-muted">(Optional)</span>-->
        </label>
        <input
          type="text"
          class="form-control"
          id="address2"
          name="address2"
          v-validate="'required|min:3'"
          v-model="user.addressLine2"
          :class="(addressFormError &&
          errors.has('addressForm.address2'))?'is-invalid':''"
          placeholder=""
										data-test="AddressFormAddress2Input"
        >
        <div
          class="invalid-feedback"
          v-if="(addressFormError && errors.has('addressForm.address2'))"
          id="dlvry-adrs-line2-error"
										data-test="AddressFormAddress2Error"
        >
          {{errors.first('addressForm.address2')}}
        </div>
      </div>
    </div>

    <div class="row m-0">
      <div class="col-md-6 mb-3">
        <label
          for="address"
          id="dlvry-adrs-place-heading"
										data-test="AddressFormPlace"
        >
          Place
        </label>
        <input
          type="text"
          class="form-control"
          id="place"
          name="place"
          v-validate="'required|min:3|max:20'"
          v-model="user.place"
          :class="(addressFormError &&
          errors.has('addressForm.place'))?'is-invalid':''"
										data-test="AddressFormPlaceInput"
        >
        <div
          class="invalid-feedback"
          v-if="(addressFormError && errors.has('addressForm.place'))"
          id="dlvry-adrs-place-error"
										data-test="AddressFormPlaceError"
        >
          {{errors.first('addressForm.place')}}
        </div>
      </div>

      <!--<div class="col-md-6 mb-3">-->
      <!--<label for="landmark" id="dlvry-adrs-lndmrk-heading">-->
      <!--Locality / Landmark-->
      <!--&lt;!&ndash;<span class="text-muted">(Optional)</span>&ndash;&gt;-->
      <!--</label>-->
      <!--<input-->
      <!--type="text"-->
      <!--class="form-control"-->
      <!--id="landmark"-->
      <!--name="landmark"-->
      <!--v-validate="'required|min:3'"-->
      <!--v-model="user.locality"-->
      <!--placeholder=""-->
      <!--:class="(addressFormError &&-->
      <!--errors.has('addressForm.landmark'))?'is-invalid':''"-->
      <!--&gt;-->
      <!--<div class="invalid-feedback"-->
      <!--v-if="(addressFormError && errors.has('addressForm.landmark'))"-->
      <!--id="dlvry-adrs-lndmrk-error"-->
      <!--&gt;-->
      <!--{{errors.first('addressForm.landmark')}}-->
      <!--</div>-->
      <!--</div>-->
      <div class="col-md-6 mb-3">
        <label
          for="country"
          id="dlvry-adrs-country-heading"
										data-test="AddressFormCountry"
        >
          Country
        </label>
        <select
          class="custom-select d-block w-100"
          id="country"
          name="country"
          v-validate="'required'"
          v-model="user.country"
          :class="((addressFormError && user.country === 'Select...') ||
          errors.has('addressForm.country'))?'is-invalid':''"
										data-test="AddressFormCountryInput"
        >
          <option disabled
																		data-test="AddressFormCountryOptn1"
																		id="AddressFormCountryOptn1">
            Select...
          </option>
          <option
            v-for="(country,index) in selectPicker(countryChoose)"
            :key="index"
            :id="'country'+index"
												:data-test="'AddressFormCountryOptn2'+index"
          >
            {{country}}
          </option>
        </select>
        <div
          class="invalid-feedback"
          v-if="(addressFormError && user.country === 'Select...') ||
          errors.has('addressForm.country')"
          id="dlvry-adrs-country-error"
										data-test="AddressFormCountryError"
										style="display: block"
        >
									The country field required
        </div>
      </div>
    </div>

    <div class="row m-0">
      <!--<div class="col-md-4 mb-3">-->
      <!--<label for="country" id="dlvry-adrs-country-heading">-->
      <!--Country-->
      <!--</label>-->
      <!--<select-->
      <!--class="custom-select d-block w-100"-->
      <!--id="country"-->
      <!--name="country"-->
      <!--v-validate="{ required: true }"-->
      <!--v-model="user.country"-->
      <!--:class="(addressFormError &&-->
      <!--errors.has('addressForm.country'))?'is-invalid':''"-->
      <!--&gt;-->
      <!--<option value="">-->
      <!--Choose...-->
      <!--</option>-->
      <!--<option v-for="(country,index) in getCountriesWithShipping"-->
      <!--:key="index"-->
      <!--:id="'country'+index"-->
      <!--&gt;-->
      <!--{{country.country_name}}-->
      <!--</option>-->
      <!--</select>-->
      <!--<div class="invalid-feedback"-->
      <!--v-if="(addressFormError && errors.has('addressForm.country'))"-->
      <!--id="dlvry-adrs-country-error"-->
      <!--&gt;-->
      <!--{{errors.first('addressForm.country')}}-->
      <!--</div>-->
      <!--</div>-->

      <!--state-->
      <div class="col-md-4 mb-3">
        <label
          for="state"
          id="dlvry-adrs-state-heading"
										data-test="AddressFormState"
        >
          State
        </label>
        <select
          class="custom-select d-block w-100"
          id="state"
          name="state"
          v-validate="{ required: true }"
          v-model="user.state"
										:class="((addressFormError && user.state === 'Select...') ||
          errors.has('addressForm.state'))?'is-invalid':''"
										data-test="AddressFormStateInput"
        >
          <option disabled
																		data-test="AddressFormStateOptn1"
																		id="AddressFormStateOptn1">
            Select...
          </option>
          <option
            v-for="(state,index) in selectPicker(countryChoose[user.country])"
            :key="index"
            :id="'state'+index"
												:data-test="'AddressFormStateOptn2'+index"
          >
            {{state}}
          </option>
        </select>
        <div
          class="invalid-feedback"
          v-if="(addressFormError && user.state === 'Select...') ||
          errors.has('addressForm.state')"
          id="dlvry-adrs-state-error"
										data-test="AddressFormStateError"
        >
									The state field required
        </div>
      </div>
      <!--district-->
      <div class="col-md-4 mb-3">
        <label
          for="district"
          id="dlvry-adrs-district-heading"
										data-test="AddressFormDistrict"
        >
          District
        </label>
        <select
          class="custom-select d-block w-100"
          id="district"
          name="district"
          v-validate="{ required: true }"
          v-model="user.locality"
										:class="((addressFormError && user.locality === 'Select...') ||
          errors.has('addressForm.district'))?'is-invalid':''"
										data-test="AddressFormDistrictInput"
        >
          <option disabled
																		data-test="AddressFormDistrictOptn1"
																		id="AddressFormDistrictOptn1">
            Select...
          </option>
          <option
            v-for="(district,index) in districtPickerData"
            :key="index"
            :id="'state'+index"
												:data-test="'AddressFormDistrictOptn2'+index"
          >
            {{district}}
          </option>
        </select>
        <div
          class="invalid-feedback"
          v-if="(addressFormError && user.locality === 'Select...') ||
          errors.has('addressForm.district')"
          id="dlvry-adrs-district-error"
										data-test="AddressFormDistrictError"
        >
									The district field required
        </div>
      </div>
      <!--<div class="col-md-3 mb-3">-->
      <!--<label for="State">Country</label>-->
      <!--<input-->
      <!--type="text"-->
      <!--class="form-control"-->
      <!--id="country"-->
      <!--name="country"-->
      <!--v-validate="{ required: true }"-->
      <!--v-model="user.country"-->
      <!--:class="(addressFormError && errors.has('addressForm.country'))?'is-invalid':''"-->
      <!--&gt;-->
      <!--<div class="invalid-feedback"-->
      <!--v-if="(addressFormError && errors.has('addressForm.country'))">-->
      <!--{{errors.first('addressForm.country')}}-->
      <!--</div>-->
      <!--</div>      &lt;!&ndash;country manual text input&ndash;&gt;-->
      <!--<div class="col-md-4 mb-3">-->
      <!--<label for="state">State</label>-->
      <!--<select class="custom-select d-block w-100"-->
      <!--id="state"-->
      <!--name="state"-->
      <!--v-validate="{ required: true }"-->
      <!--v-model="user.state"-->
      <!--:class="(addressFormError && errors.has('addressForm.state'))?'is-invalid':''"-->
      <!--&gt;-->
      <!--<option value="">Choose...</option>-->
      <!--<option>UAE</option>-->
      <!--<option>Kuwait</option>-->
      <!--<option>Oman</option>-->
      <!--</select>-->
      <!--<div class="invalid-feedback"-->
      <!--v-if="(addressFormError && errors.has('addressForm.state'))">-->
      <!--{{errors.first('addressForm.state')}}-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="col-md-4 mb-3">-->
      <!--<label for="State" id="dlvry-adrs-state-heading">-->
      <!--State / Province / Region-->
      <!--</label>-->
      <!--<input-->
      <!--type="text"-->
      <!--class="form-control"-->
      <!--id="state"-->
      <!--name="state"-->
      <!--v-validate="{ required: true }"-->
      <!--v-model="user.state"-->
      <!--:class="(addressFormError &&-->
      <!--errors.has('addressForm.state'))?'is-invalid':''"-->
      <!--&gt;-->
      <!--<div class="invalid-feedback"-->
      <!--v-if="(addressFormError && errors.has('addressForm.state'))"-->
      <!--id="dlvry-adrs-state-error"-->
      <!--&gt;-->
      <!--{{errors.first('addressForm.state')}}-->
      <!--</div>-->
      <!--</div>-->
      <div class="col-md-4 mb-3">
        <label
          for="pincode"
          id="dlvry-adrs-zip-heading"
										data-test="AddressFormPincode"
        >
          Pin Code
        </label>
        <input
          type="text"
          class="form-control"
          id="pincode"
          name="pincode"
          v-validate="'required|digits:6|numeric'"
          placeholder=""
          v-model="user.pinCode"
          :class="(addressFormError &&
          errors.has('addressForm.pincode'))?'is-invalid':''"
										data-test="AddressFormPincodeInput"
        >
        <div
          class="invalid-feedback"
          v-if="(addressFormError && errors.has('addressForm.pincode'))"
          id="dlvry-adrs-zip-error"
										data-test="AddressFormPincodeError"
        >
          {{errors.first('addressForm.pincode')}}
        </div>
      </div>
    </div>
    <!--<hr class="mb-4">-->
    <!--<div class="custom-control custom-checkbox">-->
    <!--<input type="checkbox" class="custom-control-input" id="same-address">-->
    <!--<label class="custom-control-label" for="same-address">-->
    <!--Shipping address is the same as my billing address-->
    <!--</label>-->
    <!--</div>-->
    <!--<div class="custom-control custom-checkbox">-->
    <!--<input type="checkbox" class="custom-control-input" id="save-info">-->
    <!--<label class="custom-control-label" for="save-info">
      Save this information for next time
      </label>-->
    <!--</div>-->

    <hr class="mb-4">
    <div class="pl-4 pl-md-3">
      <button
        type="submit"
        class="btn btn-primary btn-type-primary blue-btn"
        id="dlvry-adrs-savebtn"
								data-test="AddressFormSaveBtn"
      >
        Save
      </button>
      <button
        type="button"
        class="btn btn-primary btn-type-primary blue-btn"
        @click.prevent="cancelForm()"
        id="dlvry-adrs-cancelbtn"
								data-test="AddressFormCancelBtn"
      >
        Cancel
      </button>
    </div>
  </form>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
	props: {
		address: {}
	},
	computed: {
		...mapGetters('siteData', ['getSelectedCountry', 'getCountriesWithShipping', 'getShippingCountryDetails']),
		districtPickerData () {
			if (this.countryChoose && this.countryChoose[this.user.country] && this.countryChoose[this.user.country][this.user.state]) {
				return (this.countryChoose[this.user.country][this.user.state])
			}
			return []
		}
	},
	mounted () {
		if (typeof this.address !== 'undefined') {
			this.user = JSON.parse(JSON.stringify(this.address))
		}
		this.user.countryData = JSON.parse(JSON.stringify(this.getSelectedCountry))
		this.countryChoose = this.getShippingCountryDetails
	},
	watch: {
		'user.country': function () {
			this.user.countryData = JSON.parse(JSON.stringify(this.getCountriesWithShipping))
				.find(country => country.country_name === this.user.country)
		}
	},
	data () {
		return {
			user: {
				addressType: 'home',
				country: 'Select...',
				state: 'Select...',
				locality: 'Select...'
			},
			addressFormError: false,
			phone: '',
			phoneError: true,
			showError: false,
			countryChoose: {},
			state: {},
			district: {}
		}
	},
	methods: {
		cancelForm () {
			this.$emit('cancel')
		},
		action (scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result && this.user.country !== 'Select...' && this.user.state !== 'Select...' && this.user.locality !== 'Select...') {
					this.addressFormError = false

					this.$emit('submitSuccess', this.user)
				} else {
					this.addressFormError = true
				}
			})
		},
		onInput ({ number, isValid, country }) {

		},
		selectPicker (selectParentData) {
			if (selectParentData) {
				return Object.keys(selectParentData)
			}
			return []
		}
	}
}
</script>
<style lang="scss">
.vue-tel-input {
  input {
    width: 170px;
  }
}
</style>
